import { PowensUser, UnifiedAccount } from 'src/api/finconnect/usersApi';

export function extractEnrichedAccountsFromPowensUser(user: PowensUser): UnifiedAccount[] {
  if (!user?.connections) return [];

  const accounts: UnifiedAccount[] = [];

  user.connections.forEach((connection) => {
    const connector = connection.connector;
    if (!connection.accounts) return;

    connection.accounts.forEach((acc) => {
      accounts.push({
        id: acc.id,
        name: acc.name ?? 'Compte sans nom',
        balance: acc.balance ?? '',
        totalBalance: connection.balance ?? null,
        symbol: acc.currency?.symbol ?? '',
        currencyCode: acc.currency?.code ?? '',
        iban: acc.iban ?? null,
        connectorName: connector?.name ?? 'Inconnu',
        connectorSlug: connector?.slug ?? '',
        connectorColor: connector?.color ?? '#ccc',
        connectorId: connector?.id ?? 0,
        source: 'powens',
      });
    });
  });

  // 🔹 sort by connector then by account name
  return accounts.sort((a, b) => {
    if (a.connectorName === b.connectorName) {
      return a.name.localeCompare(b.name);
    }
    return a.connectorName.localeCompare(b.connectorName);
  });
}
